import { APP_TYPES } from "../../../constants/product-terminology";

/**
 * Operational template capabilities by app type.
 * Trucking is fully defined; serviceRepair keeps a compatible path for later work.
 */
export const OPERATIONAL_TEMPLATE_PROFILES = {
  [APP_TYPES.TRUCKING]: {
    supportsJobTemplates: true,
    supportsLegTemplates: true,
    job: {
      includesServiceItems: false,
      includesLoadInformation: true,
      includesChecklistGroups: true,
    },
    leg: {
      includesLoadType: true,
      includesHandoffFlags: true,
      includesMileageControls: true,
      includesWeight: true,
      includesCharges: true,
      includesRouteDefaults: true,
    },
  },
  [APP_TYPES.SERVICE_REPAIR]: {
    supportsJobTemplates: true,
    supportsLegTemplates: true,
    job: {
      includesServiceItems: true,
      includesLoadInformation: false,
      includesChecklistGroups: true,
    },
    leg: {
      includesLoadType: false,
      includesHandoffFlags: false,
      includesMileageControls: true,
      includesWeight: false,
      includesCharges: true,
      includesRouteDefaults: false,
    },
  },
};

/**
 * @param {string|null|undefined} appType
 * @returns {typeof OPERATIONAL_TEMPLATE_PROFILES[typeof APP_TYPES.TRUCKING]}
 */
export function getOperationalTemplateProfile(appType) {
  return (
    OPERATIONAL_TEMPLATE_PROFILES[appType] ||
    OPERATIONAL_TEMPLATE_PROFILES[APP_TYPES.SERVICE_REPAIR]
  );
}

/**
 * Trucking leg template toggles aligned with load leg create flows.
 */
export const TRUCKING_LEG_TEMPLATE_TOGGLES = [
  ["useLegFlatRate", "Use leg flat rate"],
  ["useCustomMileage", "Use custom mileage"],
  ["useCustomBaseCharge", "Custom base charge"],
  ["useCustomFuelSurcharge", "Custom fuel surcharge"],
  ["useCustomDropCharge", "Custom drop charge"],
  ["useCustomOtherCharges", "Custom other charges"],
  ["hasHandoff", "Has handoff"],
  ["isHandoff", "Is handoff"],
];
